
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/transactions",
      function () {
        return require("private-next-pages/admin/transactions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/transactions"])
      });
    }
  